import { gql } from "@apollo/client";

export const JOIN_WAITLIST_MUTATION = gql`
    mutation JoinWaitlist($input: JoinWaitlistInput!) {
        joinWaitlist(input: $input) {
            scheduleItemAttendance {
                id
                bookingStatus
                isWaitlisted
                waitlistPosition
            }
        }
    }
`;

export const CANCEL_WAITLIST_MUTATION = gql`
    mutation CancelWaitlist($input: CancelWaitlistInput!) {
        cancelWaitlist(input: $input) {
            scheduleItemAttendance {
                id
                bookingStatus
                isWaitlisted
            }
        }
    }
`;

export { GET_SHOP_FEATURES_QUERY } from "../../../schedule/classes/all/waitlist/queries";
